/*eslint no-undef:0*/
(function () {
    'use strict';

    angular
        .module('utils', [
            'components.api'
        ])
        .constant('moment', moment);
})();